import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=b4ae284a&scoped=true&"
import script from "./CodeSnippet.vue?vue&type=script&lang=js&"
export * from "./CodeSnippet.vue?vue&type=script&lang=js&"
import style0 from "./CodeSnippet.vue?vue&type=style&index=0&id=b4ae284a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ae284a",
  null
  
)

export default component.exports